import React from 'react';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
import { useLang } from '@/i18n';
const OnlineStoreRightsNa: React.FC = () => {
    const { t } = useLang('theProduct.OnlineStoreRightsNa');
    return (
        <section className={styles.OnlineStoreRightsNa}>
            <div className="rights-container">
                <div className="item1 item">
                    <div className="item-content">
                        <p className="item-desc">
                            <span className="gradient-text">{t('online_store_g_1')}</span>
                        </p>
                        <p className="item-desc">{t('online_store_desc_1')}</p>
                    </div>
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1746177713808/Frame%20161269800-pc.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1746177713808/Frame%20161269800-pc.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1746177716156/Frame%20161269800-h5.jpg"
                    ></EcoImg>
                </div>
                <div className="item2 item">
                    <div className="item2-top">
                        <div className="item-content">
                            <p className="item-desc">
                                {t('online_store_desc_2_before')}
                                <span className="gradient-text">{t('online_store_g_2')}</span>
                            </p>
                            <p className="item-desc">{t('online_store_desc_2_after')}</p>
                        </div>
                        <EcoImg
                            className="item-img"
                            pc="https://websiteoss.ecoflow.com/upload/image/1746174584879/Frame%20161269784.jpg"
                            pad="https://websiteoss.ecoflow.com/upload/image/1746174584879/Frame%20161269784.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1746174601944/Frame%201612706829.jpg"
                        ></EcoImg>
                    </div>
                    <div className="item2-bottom">
                        <p className="title">UL1741-Certified & IEEE1547-Certified</p>
                    </div>
                </div>
                <div className="item3 item">
                    <div className="item-content">
                        <p className="item-desc">
                            <span className="gradient-text">{t('online_store_g_3')}</span>
                        </p>
                        <p className="item-desc">{t('online_store_desc_3')}</p>
                    </div>
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1745205841973/pc-rights-item3.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1745205841973/pc-rights-item3.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1745224855827/m-rights-item3.jpg"
                    ></EcoImg>
                </div>
                <div className="item4 item">
                    <div className="item-content">
                        <p className="item-desc">
                            <span className="gradient-text">{t('online_store_g_4')}</span>
                            {t('online_store_desc_4')}
                        </p>
                        <p className="item-desc"></p>
                    </div>
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1744965994494/pc-rights-item4.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1744965994494/pc-rights-item4.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1745224855574/m-rights-item4.jpg"
                    ></EcoImg>
                </div>
                <div className="item5 item">
                    <div className="item-content">
                        <p className="item-desc">
                            <span className="gradient-text">{t('online_store_g_5')}</span>
                        </p>
                        <p className="item-desc">{t('online_store_desc_5')}</p>
                    </div>
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1744966358021/pc-rights-item5.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1744966358021/pc-rights-item5.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1745224855272/m-rights-item5.jpg"
                    ></EcoImg>
                </div>
                <div className="item6 item">
                    <div className="item-content">
                        <p className="item-desc">
                            <span className="gradient-text">{t('online_store_g_6')}</span>
                        </p>
                        <p className="item-desc">{t('online_store_desc_6')}</p>
                    </div>
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1744965995440/pc-rights-item6.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1744965995440/pc-rights-item6.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1745224857157/m-rights-item6.jpg"
                    ></EcoImg>
                </div>
                <div className="item7 item">
                    <div className="item-content">
                        <p className="item-desc">
                            <span>{t('online_store_g_7')}</span>
                        </p>
                        <p className="item-desc gradient-text">
                            <span className="gradient-text">{t('online_store_desc_7')}</span>
                        </p>
                    </div>
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1752548427704/pc.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1752548427704/pc.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1752548428552/h5.jpg"
                    ></EcoImg>
                </div>
                <div className="item8 item">
                    <div className="item-content">
                        <p className="item-desc">
                            {t('online_store_g_8')}
                            <br />
                            <span className="gradient-text">{t('online_store_desc_8')}</span>
                        </p>
                        <p className="item-desc"></p>
                    </div>
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1744965995259/pc-rights-item8.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1744965995259/pc-rights-item8.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1745224856597/m-rights-item8.jpg"
                    ></EcoImg>
                </div>
                <div className="item9 item">
                    <div className="item-content">
                        <div className="item-desc">
                            <p className="gradient-text top"> {t('online_store_g_9_top')}</p>
                            <p className="gradient-text bottom"> {t('online_store_g_9_bottom')}</p>
                        </div>
                        {/* <p className="opacity-text">4 MPPT</p> */}
                    </div>
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1746174151610/Frame%20161269788%20(1).jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1746174151610/Frame%20161269788%20(1).jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1746174408854/Frame%20161269801%20(1).jpg"
                    ></EcoImg>
                </div>
            </div>
        </section>
    );
};

export default OnlineStoreRightsNa;
